let initialized = false;

export default {
  /* eslint-disable */

  init(companyId) {
    if (initialized || document.querySelector(`script[src*="${companyId}"]`))
      return;

    window._learnq = window._learnq || [];
    window._learnq.push(["account", companyId]);

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${companyId}`;

    script.onload = () => {
      initialized = true;
    };

    script.onerror = () => {};

    document.head.appendChild(script);
  },
  track(event, userData, data) {
    if (!window.klaviyo) return;
    /* eslint-disable */

    window.klaviyo.identify(userData);
    window.klaviyo.track(event, data);

    /* eslint-enable */
  },
  isInitialized() {
    return initialized;
  },
};
